import React, { useCallback, useMemo } from 'react';
import './mediaHotspotLine.scss';

const MediaHotspot = ({ media, height, goToScene, handleApartmentPopup }) => {
  const contents = useMemo(() => {
    const res = [];
    const title = media.title || '';
    if (title && title !== '.') {
      res.push(title);
    }
    const description = (media.infoTag?.text || '').split('\n');
    res.push(...description);
    return res;
  }, [media]);

  const imgUrl = useMemo(() => {
    if (media.type === 'Image') {
      return media.imageURL;
    }
    return null;
  }, [media]);

  const isSalesGallery = useMemo(() => media.id === 'sales-gallery', [media]);

  const getContainerHeight = useMemo(() => {
    const heightMap = {
      'Tan An City': '110px',
      'Tan Duc Industrial Park': '90px',
      'Water Point Nam Long': '150px',
      'Vinhome Green City': '130px',
      'Aeon Mall Binh Tan': '150px',
      'Nhi Dong 2 Hospital': '110px',
      'Tan Tao University': '40px',
      LAHOME: '60px',
      'Idico Huu Thanh Industrial Park': '90px',
      'Vo Van Tan Park': '40px',
      'Cau Xang Market': '50px',
      'Tan Tao Medical University Hospital': '60px',
      'Mien Tay Bus Station': '100px',
    };

    for (const text of contents) {
      if (text && heightMap[text.trim()]) {
        return heightMap[text.trim()];
      }
    }

    if (height) {
      return `${height * 50}px`;
    }

    return '75px';
  }, [contents, height]);

  const onHover = () => {};

  const handleClick = useCallback(() => {
    if (isSalesGallery) {
      // goToScene('can-ho-mau', '2');
      handleApartmentPopup();
    }
  }, [isSalesGallery, handleApartmentPopup]);

  return (
    <div
      className={`khp-media-hotspot ${isSalesGallery ? 'big-bottom' : ''}`}
      onMouseEnter={onHover}
      onClick={handleClick}
    >
      <div
        className="khp-media-hotspot__container"
        style={{ height: getContainerHeight }}
      >
        <div className="khp-media-hotspot__title bcons-text">
          {contents.map((txt, index) => (
            <p key={index} className={contents.length > 2 ? 'text-left' : ''}>
              {txt}
            </p>
          ))}
          {imgUrl && (
            <img
              className="khp-media-hotspot__preview"
              src={imgUrl}
              alt={media.title}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaHotspot;
